// extracted by mini-css-extract-plugin
export default {"formContainer":"CategorieForm_formContainer__B5Dfs"};